<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M557.2,206.8l-124.1-124c-12-12-28.3-18.7-45.3-18.7h-135.6c-17,0-33.3,6.7-45.3,18.7l-124.1,124.2c-12,12-18.7,28.2-18.7,45.2v135.6c0,17,6.7,33.3,18.7,45.3l124.2,124.1c12,12,28.3,18.7,45.3,18.7h135.6c17,0,33.3-6.7,45.3-18.7l124-124.2c12-12,18.7-28.3,18.7-45.3v-135.6c0-17-6.7-33.3-18.7-45.3ZM320,170.4c17.7,0,32.1,14.4,32.1,32.1s-14.4,32.1-32.1,32.1-32.1-14.4-32.1-32.1,14.4-32.1,32.1-32.1ZM370,469.6h-100c-13.8,0-25-7.8-25-17.5s11.2-17.5,25-17.5h25v-122.3h-25c-13.8,0-25-7.8-25-17.5s11.2-17.5,25-17.5h50c13.8,0,25,7.8,25,17.5v139.8h25c13.8,0,25,7.8,25,17.5s-11.2,17.5-25,17.5Z"
      fill="currentColor"
    />
  </svg>
</template>